"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelsConsumer = void 0;
class ChannelsConsumer {
    // eslint-disable-next-line
    constructor(channel) {
        this.channel = channel;
        this.getExposedFunctions = async (options) => {
            const { id } = options;
            const { props } = await this.channel.dispatch(`api-meta:${id}`);
            return props;
        };
        this.createFunction = (prop) => (...args) => {
            const { action } = prop.options;
            return this.channel.dispatch(action, { args });
        };
    }
    ;
}
exports.ChannelsConsumer = ChannelsConsumer;
